import SchoolCircular from "../components/pages/SchoolCirculars";

export default SchoolCircular;
